module.exports = new __parcel__URL__("druid.a6091e44.png").toString();